import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {componentFilter, dateFilter, optionFilter} from "../../../utils/filters";
import {postData} from "../../../utils/request";
import Button from "../../form/Button";
import Icon from "../../form/Icon";
import {ComponentFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";

class StoreorderList extends React.Component {

    state = {
        send: false
    };

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "storeorderList"}
                {...props}
                view={["state","StoreOrderState.optionid"]}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "fullnotenum": {
                        header: 'Szállítólevél szám',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "orderdate": {
                        header: 'Rendelés dátuma',
                        width: 2,
                        sortable,
                        filterable: dateFilter()
                    },
                    ...(this.props.client === undefined ? {
                        "client.partner.name": {
                            header: 'Partner',
                            width: 2,
                            sortable,
                            filterable
                        },
                        "client.destination.name": {
                            header: 'Hova',
                            width: 2,
                            sortable,
                            filterable
                        },
                    } : {}),
                    "store.name": {
                        header: 'Raktár',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "StoreOrderState.optionlabel": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        filterField: 'state',
                        operator: '=',
                        filterable: optionFilter("storeorder_state")
                    },
                    ...(this.props.clientFields ? {
                        "client_component": {
                            header: 'Tevékenység',
                            width: 2,
                            sortable,
                            filterable: componentFilter({component: []}),
                            renderer: (value) => ComponentFormatter({component: value})

                        },
                        "client_component_id": {
                            header: 'Id',
                            width: 2,
                            sortable,
                            filterable
                        },
                    } : {
                        "ordertype": {
                            header: 'Típus',
                            width: 1,
                            sortable,
                            filterable: <Select
                                storeType="local"
                                options={[
                                    {key: "0", label: "Kiszedés"},
                                    {key: "1", label: "Bevételezés"}
                                ]}
                                label={false}
                                objectValue={false}
                                isClearable={true}
                                valueKey="key"
                                labelKey="label"
                            />,
                            renderer: (value) => ({"0": "Kiszedés","1": "Bevételezés"})[value]
                        },
                    }),
                    "actions": {
                        header: <Icon lib="fa" name="print"/>,
                        width: 1,
                        renderer: (value, rowData) =>
                            <Button
                                type="button"
                                block={true}
                                color="default"
                                size="xs"
                                tooltip="Dokumentumok újraküldése a raktárnak"
                                icon={{lib: "fas", name: this.state.send ? "sync-alt" : "share", spin: this.state.send}}
                                disabled={isLoading || this.state.send}
                                onClick={(e) => {
                                    e && e.stopPropagation();
                                    e && e.preventDefault();
                                    this.setState({send: true}, async () => {
                                        try {
                                            await this.props.processAction(async () => {
                                                await postData({
                                                    action: componentConfig.componentname + '.requestDocuments',
                                                    data: rowData
                                                });
                                                return false;
                                            });
                                        } catch (e) {

                                        }
                                        this.setState({send: false});
                                    });
                                    return false;
                                }}
                            >

                            </Button>
                    }
                }}
                rowClassName={(rowData) => {
                    if (rowData.state + "" === "2") {
                        return {"warning": true};
                    } else if (rowData.state + "" === "3") {
                        return {"success": true};
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default StoreorderList;
